if (!customElements.get('contact-form-ajax')) {
  customElements.define(
    'contact-form-ajax',
    class ContactFormAjax extends HTMLElement {
      constructor() {
        super();
        const forms = this.querySelectorAll('.trade-contact-form');

        if (forms.length > 0) {
          console.log(`Found ${forms.length} forms`);
          forms.forEach((form) => {
            const submitButton = form.querySelector('button[data-action="submit"]');
            submitButton.addEventListener('click', (event) => {
              event.preventDefault();
              this.sendForm(form);
              this.submitFormIntoGoogleSheet(form);
              return false;
            });

            form.addEventListener('submit', (event) => {
              event.preventDefault();
              this.sendForm(form);
              this.submitFormIntoGoogleSheet(form);
              return false;
            });

            // hide both success and error messages if user clicks outside the form
            document.addEventListener('click', (event) => {
              if (!form.contains(event.target) || event.target === form) {
                this.resetForm(form);
              }
            });
          });
        } else {
          console.error('No forms found');
        }

        // Store forms and their elements in instance properties
        this.forms = forms;
        this.formElements = Array.from(forms).map((form) => ({
          form: form,
          submitButton: form.querySelector('[data-action="submit"]'),
          successMessage: form.querySelector('.success_message'),
          errorMessage: form.querySelector('.error_message'),
        }));
      }

      // Function to get URL parameters for tracking
      getURLParameters() {
        const searchParams = new URLSearchParams(window.location.search);
        return {
          utm_source: searchParams.get('utm_source') || '',
          utm_medium: searchParams.get('utm_medium') || '',
          utm_campaign: searchParams.get('utm_campaign') || '',
          utm_content: searchParams.get('utm_content') || '',
          utm_term: searchParams.get('utm_term') || '',
        };
      }
      // Function to get source data
      getSourceData() {
        return {
          referrer: document.referrer || 'direct',
          landing_page: window.location.href,
          utm_params: this.getURLParameters(),
        };
      }
      async sendForm(form) {
        const formData = new FormData(form);
        if (!form.reportValidity()) return;
        form.classList.add('sending');
        form.querySelector('button').innerHTML = 'Sending...';
        fetch('/contact', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        })
          .then((response) => {
            console.log({ response });
            if (response.ok) {
              console.log('Network response was ok');
            } else {
              console.log('Network response was not ok');
              //form.action = form.dataset.action;
              //form.submit();
            }
            form.classList.add('sent');
            form.querySelector('.success_message').classList.remove('hidden');
            // hide success message after 5 seconds
            return response.text();
          })
          .then((data) => {
            console.log({ data });
          })
          .catch((error) => {
            console.error('Error:', error);
            form.classList.add('sent');
            form.querySelector('.error_message').classList.remove('hidden');
            // hide error message after 5 seconds
          })
          .finally(() => {
            setTimeout(() => {
              this.resetForm(form);
            }, 5000);
          });
      }

      async submitFormIntoGoogleSheet(form) {
        const formData = new FormData(form);
        console.log('formData', formData);

        if (!form.reportValidity()) return;
        let submission_url = '';
        let formFields;

        // Check if this is a form with sheet_name input
        const sheetNameInput = form.querySelector('input[name="contact[sheet_name]"]');

        if (sheetNameInput) {
          console.log('sheetNameInput', sheetNameInput);

          // Get the sheet name and form type
          const sheetName = formData.get('contact[sheet_name]');
          const formType = formData.get('contact[form_type]');

          // Get referrer and UTM data
          const sourceData = this.getSourceData();

          // Create the payload object
          const payload = {
            sheetName: sheetName,
            data: {
              referrer: sourceData.referrer,
              landing_page: sourceData.landing_page,
              utm_params: sourceData.utm_params,
              createdAt: new Date().toISOString(),
            },
          };

          // Add all form fields to the data object except the special fields
          for (let [key, value] of formData.entries()) {
            // Skip the special fields we don't want in the payload
            if (
              !key.includes('contact[sheet_name]') &&
              !key.includes('contact[form_type]') &&
              !key.includes('contact[pageUrl]') &&
              !key.includes('utf8') &&
              !key.includes('contact[by-submitting') &&
              !key.includes('form_type')
            ) {
              // Remove 'contact[' and ']' from the key name
              const cleanKey = key.replace('contact[', '').replace(']', '');
              payload.data[cleanKey] = value;
            }
          }

          submission_url = 'https://wf-b2bform-to-google-sheet-7b9df709559b.herokuapp.com/submit-general';
          // submission_url = 'http://localhost:3000/submit-general';

          console.log('payload', payload);

          // Send the request
          fetch(submission_url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
          })
            .then((response) => {
              console.log({ response });
              if (response.ok) {
                console.log('Network response was ok');
              } else {
                console.log('Network response was not ok');
              }
              return response.text();
            })
            .then((data) => {
              console.log({ data });
            })
            .catch((error) => {
              console.error('Error:', error);
            });

          return; // Exit the function here
        }

        // If no sheet_name input, continue with existing logic
        const formPage = form.querySelector('input[name="contact[pageUrl]"]').value;

        // Get referrer and UTM data
        const referrer = document.referrer || 'direct';
        const utmParams = {
          utm_source: new URLSearchParams(window.location.search).get('utm_source') || '',
          utm_medium: new URLSearchParams(window.location.search).get('utm_medium') || '',
          utm_campaign: new URLSearchParams(window.location.search).get('utm_campaign') || '',
          utm_content: new URLSearchParams(window.location.search).get('utm_content') || '',
          utm_term: new URLSearchParams(window.location.search).get('utm_term') || '',
        };

        // Track form submission in dataLayer
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'form_submit',
            formName: 'Trade Contact Form',
            formId: 'trade-contact-form',
            form_destination: window.location.href,
            form_length: form.elements.length,
            referrer: referrer,
          });
        }

        if (formPage.includes('win-wildfarmed-bread')) {
          formFields = {
            createdAt: new Date(),
            firstName: ' ',
            lastName: ' ',
            email: ' ',
            gender: '',
            alreadyHeard: ' ',
            receiveMarketing: ' ',
            shouldBeContacted: ' ',
            referrer: referrer,
            utm_params: utmParams,
          };
          for (let [key, value] of formData.entries()) {
            if (key.includes('email')) {
              formFields.email = value;
            } else if (key.includes('first_name')) {
              formFields.firstName = value;
            } else if (key.includes('last_name')) {
              formFields.lastName = value;
            } else if (key.includes('tick-to-opt-in-to-receive-marketing-materials')) {
              formFields.receiveMarketing = value;
            } else if (key.includes('where_did_you_hear_of_wildfarmed')) {
              formFields.alreadyHeard = value;
            } else if (key.includes('gender')) {
              formFields.gender = value;
            } else if (key.includes('contact[tick-to-agree-to-being-contacted-if-you-win]')) {
              formFields.shouldBeContacted = value;
            } else {
              console.log(key);
            }
          }
          submission_url = 'https://wf-b2bform-to-google-sheet-7b9df709559b.herokuapp.com/win-bread';
        } else if (formPage.includes('win-with-wildfarmed')) {
          formFields = {
            createdAt: new Date(),
            name: ' ',
            age: ' ',
            email: ' ',
            gender: ' ',
            hearAboutUs: ' ',
            referrer: referrer,
            landing_page: window.location.href,
            utm_params: utmParams,
          };
          for (let [key, value] of formData.entries()) {
            if (key.includes('email')) {
              formFields.email = value;
            } else if (key.includes('first_name')) {
              formFields.name = value;
            } else if (key.includes('last_name')) {
              formFields.age = value;
            } else if (key.includes('gender')) {
              formFields.gender = value;
            } else if (key.includes('where_did_you_hear_of_wildfarmed')) {
              formFields.hearAboutUs = value;
            } else if (key.includes('tick-to-opt-in-to-receive-marketing-materials')) {
              formFields.receiveMarketing = Boolean(value) ? true : false;
            }
          }
          submission_url = 'https://wf-b2bform-to-google-sheet-7b9df709559b.herokuapp.com/win-with-wildfarmed';
          // submission_url = 'http://localhost:3000/win-with-wildfarmed';
        } else {
          // Create an empty object to store the form data
          formFields = {
            createdAt: new Date(),
            firstName: ' ',
            lastName: ' ',
            email: ' ',
            hearAboutUs: ' ',
            postCode: ' ',
            company: ' ',
            message: ' ',
            referrer: referrer,
            landing_page: window.location.href,
            utm_params: utmParams,
          };
          // Iterate over each form field (key-value pair)
          for (let [key, value] of formData.entries()) {
            if (key.includes('body')) {
              formFields.message = value;
            } else if (key.includes('company')) {
              formFields.company = value;
            } else if (key.includes('email')) {
              formFields.email = value;
            } else if (key.includes('first_name')) {
              formFields.firstName = value;
            } else if (key.includes('last_name')) {
              formFields.lastName = value;
            } else if (key.includes('post_code')) {
              formFields.postCode = value;
            } else if (key.includes('how_did_you_hear_about_us')) {
              formFields.hearAboutUs = value;
            }
          }
          submission_url = 'https://wf-b2bform-to-google-sheet-7b9df709559b.herokuapp.com/submit-trade';
        }
        console.log('Submission URL:', submission_url);
        console.log(JSON.stringify(formFields));
        fetch(submission_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formFields),
        })
          .then((response) => {
            console.log({ response });
            if (response.ok) {
              console.log('Network response was ok');
            } else {
              console.log('Network response was not ok');
            }
            return response.text();
          })
          .then((data) => {
            console.log({ data });
          })
          .catch((error) => {
            console.error('Error:', error);
            // hide error message after 5 seconds
          });
      }

      resetForm(form) {
        //form.reset();
        form.classList.remove('sent');
        form.classList.remove('sending');
        form.querySelector('.success_message').classList.add('hidden');
        form.querySelector('.error_message').classList.add('hidden');
        form.querySelector('button').innerHTML = 'GET IN TOUCH';
      }
    }
  );
}
